import React from 'react';
import type { ServicesContextType } from 'Context/ServicesContext';
import { ServicesContext } from 'Context/ServicesContext';
import { LayerActivities } from 'Components/widgets/layer-activities/LayerActivities';
type Props = PropsWithPageTracking<{
  categories: Array<ActivitiesCategoryEntity>;
  children: React.ReactNode;
  contextValue: ServicesContextType;
  thematics: Array<ActivitiesThematicEntity>;
}>;
export const ActivitiesBooking = ({
  categories,
  children,
  contextValue,
  thematics,
  ...rest
}: Props) => (
  <ServicesContext.Provider value={contextValue}>
    {children}
    <LayerActivities {...rest} categories={categories} thematics={thematics} />
  </ServicesContext.Provider>
);
